import { Color } from 'styled/theme/colors';

export const GeneralModuleColorMap: {
  [hexColor: string]: GeneralModuleColor;
} = {
  '#bed4fc': 'BLUE',
  '#e4f4f5': 'GREEN',
  '#fdefc8': 'ORANGE',
  '#f8edeb': 'ROSE',
  '#f7f7f7': 'GRAY',
  '#ffffff': 'WHITE',
};

export type GeneralModuleColor =
  | 'BLUE'
  | 'GREEN'
  | 'ORANGE'
  | 'ROSE'
  | 'GRAY'
  | 'WHITE';

export interface GeneralModuleColorValue {
  text: Color;
  background: Color;
  darkBackground: Color;
}

export const GeneralModuleColorScheme: {
  [color in GeneralModuleColor]: GeneralModuleColorValue;
} = {
  BLUE: {
    text: 'black',
    background: 'blue-lightest',
    darkBackground: 'blue-lighter',
  },
  GREEN: {
    text: 'black',
    background: 'green-lightest',
    darkBackground: 'green-lighter',
  },
  ORANGE: {
    text: 'black',
    background: 'orange-lightest',
    darkBackground: 'orange-lighter',
  },
  ROSE: {
    text: 'black',
    background: 'rose-lightest',
    darkBackground: 'rose-lighter',
  },
  GRAY: {
    text: 'black',
    background: 'gray-lightest',
    darkBackground: 'gray-lighter',
  },
  WHITE: {
    text: 'black',
    background: 'white',
    darkBackground: 'gray-lightest',
  },
};

export const EmphasizeModuleColorMap: {
  [hexColor: string]: EmphasizeModuleColor;
} = {
  '#8348ef': 'PURPLE',
  '#183d85': 'NAVY',
  '#162d5b': 'DARK_BLUE',
  '#196cff': 'BLUE',
  '#bed4fc': 'LIGHTEST_BLUE',
  '#719b9d': 'GREEN',
  '#e4f4f5': 'LIGHTEST_GREEN',
  '#ca822f': 'ORANGE',
  '#fdefc8': 'LIGHTEST_ORANGE',
  '#c6806c': 'ROSE',
  '#f8edeb': 'LIGHTEST_ROSE',
  '#ffffff': 'WHITE',
};

export type EmphasizeModuleColor =
  | 'PURPLE'
  | 'NAVY'
  | 'DARK_BLUE'
  | 'BLUE'
  | 'LIGHTEST_BLUE'
  | 'GREEN'
  | 'LIGHTEST_GREEN'
  | 'ORANGE'
  | 'LIGHTEST_ORANGE'
  | 'ROSE'
  | 'LIGHTEST_ROSE'
  | 'WHITE';

//Header, Footer, Single-Block CTA
//If you change the background color, make sure fill-80 of that color to exist for article nav.
export const EmphasizeModuleColorScheme: {
  [color in EmphasizeModuleColor]: {
    text: Color;
    background: Color;
  };
} = {
  PURPLE: {
    text: 'white',
    background: 'purple',
  },
  NAVY: {
    text: 'white',
    background: 'navy',
  },
  DARK_BLUE: {
    text: 'white',
    background: 'blue-darkest',
  },
  BLUE: {
    text: 'white',
    background: 'blue',
  },
  LIGHTEST_BLUE: {
    text: 'black',
    background: 'blue-lightest',
  },
  GREEN: {
    text: 'white',
    background: 'green',
  },
  LIGHTEST_GREEN: {
    text: 'black',
    background: 'green-lightest',
  },
  ORANGE: {
    text: 'white',
    background: 'orange',
  },
  LIGHTEST_ORANGE: {
    text: 'black',
    background: 'orange-lightest',
  },
  ROSE: {
    text: 'white',
    background: 'rose',
  },
  LIGHTEST_ROSE: {
    text: 'black',
    background: 'rose-lightest',
  },
  WHITE: {
    text: 'black',
    background: 'white',
  },
};

export const SplitCtaColorMap: { [hexColor: string]: SplitCtaColor } = {
  '#adcafe': 'BLUE',
  '#d3ecee': 'GREEN',
  '#ca822f': 'DARK_ORANGE',
  '#ffe19f': 'ORANGE',
  '#f7ded7': 'ROSE',
  '#ffffff': 'WHITE',
};

export type SplitCtaColor =
  | 'BLUE'
  | 'GREEN'
  | 'DARK_ORANGE'
  | 'ORANGE'
  | 'ROSE'
  | 'WHITE';

export const SplitCtaColorScheme: {
  [color in SplitCtaColor]: {
    text: Color;
    arrow: Color;
    background: Color;
    section: Color;
    sectionHover: Color;
  };
} = {
  BLUE: {
    text: 'black',
    arrow: 'blue-darkest',
    background: 'blue-lighter',
    section: 'blue-lightest',
    sectionHover: 'blue-light',
  },
  GREEN: {
    text: 'black',
    arrow: 'green-darkest',
    background: 'green-lighter',
    section: 'green-lightest',
    sectionHover: 'green-light',
  },
  DARK_ORANGE: {
    text: 'white',
    arrow: 'orange-darkest',
    background: 'orange',
    section: 'orange-light',
    sectionHover: 'orange-lighter',
  },
  ORANGE: {
    text: 'black',
    arrow: 'orange-darkest',
    background: 'orange-lighter',
    section: 'orange-lightest',
    sectionHover: 'orange-light',
  },
  ROSE: {
    text: 'black',
    arrow: 'rose-darkest',
    background: 'rose-lighter',
    section: 'rose-lightest',
    sectionHover: 'rose-light',
  },
  WHITE: {
    text: 'black',
    arrow: 'black',
    background: 'white',
    section: 'gray-lighter',
    sectionHover: 'gray-light',
  },
};

export const CalloutColorMap: { [hexColor: string]: CalloutColor } = {
  '#bed4fc': 'BLUE',
  '#e4f4f5': 'GREEN',
  '#f9ae0f': 'DARK_ORANGE',
  '#fdefc8': 'ORANGE',
  '#ab7060': 'DARKER_ROSE',
  '#f3ab96': 'DARK_ROSE',
  '#f8edeb': 'ROSE',
};

export type CalloutColor =
  | 'BLUE'
  | 'GREEN'
  | 'DARK_ORANGE'
  | 'ORANGE'
  | 'DARKER_ROSE'
  | 'DARK_ROSE'
  | 'ROSE';

export const CalloutColorScheme: {
  [color in CalloutColor]: {
    background: Color;
    supportingSectionBackground: Color;
    supportingSectionText: Color;
    infoSectionBackground: Color;
    infoSectionText: Color;
  };
} = {
  BLUE: {
    background: 'white',
    supportingSectionBackground: 'blue-lighter',
    supportingSectionText: 'black',
    infoSectionBackground: 'blue-lightest',
    infoSectionText: 'black',
  },
  GREEN: {
    background: 'white',
    supportingSectionBackground: 'green-lighter',
    supportingSectionText: 'black',
    infoSectionBackground: 'green-lightest',
    infoSectionText: 'black',
  },
  DARK_ORANGE: {
    background: 'white',
    supportingSectionBackground: 'orange-dark',
    supportingSectionText: 'white',
    infoSectionBackground: 'orange-light',
    infoSectionText: 'black',
  },
  ORANGE: {
    background: 'white',
    supportingSectionBackground: 'orange-lighter',
    supportingSectionText: 'black',
    infoSectionBackground: 'orange-lightest',
    infoSectionText: 'black',
  },
  DARKER_ROSE: {
    background: 'white',
    supportingSectionBackground: 'rose-darker',
    supportingSectionText: 'white',
    infoSectionBackground: 'rose-dark',
    infoSectionText: 'white',
  },
  DARK_ROSE: {
    background: 'white',
    supportingSectionBackground: 'rose-dark',
    supportingSectionText: 'white',
    infoSectionBackground: 'rose-light',
    infoSectionText: 'black',
  },
  ROSE: {
    background: 'white',
    supportingSectionBackground: 'rose-lighter',
    supportingSectionText: 'black',
    infoSectionBackground: 'rose-lightest',
    infoSectionText: 'black',
  },
};
